export default __webpack_public_path__ + "static/media/Facebook.913a31b1.svg";